import { remToPx, stripUnit } from 'polished'

export const remToNumberOfPixels = (value: string): number => Number(stripUnit(remToPx(value)))

export const bytesToMegaBytes = (size: number): number => Number((size / 1_048_576).toFixed(2))
